
import { defineComponent } from "vue";
// import Swiper core and required modules
import { Navigation, A11y, Autoplay } from "swiper";

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue.js";

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/modules/navigation/navigation.min.css";
import "swiper/modules/pagination/pagination.min.css";
import "swiper/modules/scrollbar/scrollbar.min.css";

export default defineComponent({
  props: ["partnerModule"],
  components: {
    Swiper,
    SwiperSlide
  },
  setup() {
    const autoPlayOptions = {
      disableOnInteraction: false, // 鼠标滑动后继续自动播放
      delay: 0 //4秒切换一次
    };

    return {
      modules: [Navigation, A11y, Autoplay],
      autoPlayOptions
    };
  }
});
